const schema = () => ({
  type: "object",
  required: [],
  properties: {
    balance: {
      type: "number",
      title: "balance",
    },
  },
});

export default schema;
